import { api, URLs } from '@/libs/api'
import type { ApiResponse, OrgProfile } from '@/libs/interfaces'
import { IS_MOCK_MODE } from '@/libs/mocks/config'
import { orgApiMock } from '@/libs/mocks/handlers/org'

const orgApiReal = {
  getProfile: async (orgID: string): Promise<OrgProfile> =>
    api
      .get<ApiResponse<OrgProfile>>(URLs.Org.profile(orgID))
      .then((response) => response.data.data),
}

export const orgApi: typeof orgApiReal = IS_MOCK_MODE ? orgApiMock : orgApiReal
